import { useEffect } from "react";

import { BaseLayout } from "components/base-layout";
import { Stack } from "components/common/stack";
import { InsuranceRepresentative } from "components/shared/insurance-representative";
import { MainLayout } from "components/shared/main-layout";
import { SupportSidebar } from "components/shared/support-sidebar";
import { useEligibleCoverages } from "data/ss-data-hooks";
import { useFaqs } from "hooks/use-faqs";
import { getQueryParameter, logError } from "utils";

import FAQList from "./faq-list";

const Support = () => {
  const { data, error, isLoading } = useEligibleCoverages();

  const openQuestion = getQueryParameter("question");
  const displayedFAQs = useFaqs({
    noUpsell: data?.coverages?.length === 0,
  });

  // We're purposely logging and ignoring errors here.
  // We just hide the one faq dependent on it
  useEffect(() => {
    if (error) {
      logError(`Use get eligible coverages: (${error.message})`);
    }
  }, [error]);

  const Sidebar = () => (
    <Stack>
      <SupportSidebar />
      <InsuranceRepresentative />
    </Stack>
  );

  return (
    <BaseLayout
      availableNotifications={["HomeServices", "CancellationPayment"]}
    >
      <MainLayout sidebar={<Sidebar />} mainLoading={isLoading}>
        <Stack>
          <FAQList displayedFAQs={displayedFAQs} openQuestion={openQuestion} />
        </Stack>
      </MainLayout>
    </BaseLayout>
  );
};

export default Support;
